(() => {
  const mq = window.matchMedia('(min-width: 990px)');

  function setup() {
    const headerMenus = document.querySelectorAll('header-menu > details.mega-menu');
    headerMenus.forEach((details) => {
      const headerMenu = details.parentElement; // <header-menu>
      if (!headerMenu) return;

      let closeTimer;

      const open = () => {
        window.clearTimeout(closeTimer);
        // sluit andere open mega menus
        document.querySelectorAll('header-menu > details.mega-menu[open]').forEach((d) => {
          if (d !== details) d.removeAttribute('open');
        });
        details.setAttribute('open', '');
      };

      const close = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          details.removeAttribute('open');
        }, 120); // kleine delay voorkomt flikkeren
      };

      // dubbele listeners voorkomen
      if (details.dataset.hoverBound) return;
      details.dataset.hoverBound = '1';

      headerMenu.addEventListener('mouseenter', () => {
        if (!mq.matches) return;
        open();
      });

      headerMenu.addEventListener('mouseleave', () => {
        if (!mq.matches) return;
        close();
      });
    });
  }

  // init + bij resize
  setup();
  mq.addEventListener?.('change', setup);
})();
